import { render } from "./KonfirmHapusPelanggan.vue?vue&type=template&id=6cdfc8ff&scoped=true"
import script from "./KonfirmHapusPelanggan.vue?vue&type=script&lang=js"
export * from "./KonfirmHapusPelanggan.vue?vue&type=script&lang=js"

import "./KonfirmHapusPelanggan.vue?vue&type=style&index=0&id=6cdfc8ff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cdfc8ff"

export default script